import React from "react";
import ReactPaginate from 'react-paginate';
import { SelectSingleInput } from "../../Inputs/SelectInput";

export interface IProps {
  total: number;
  perPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onPerPageChange: (perPage: number) => void;
}

const PER_PAGE_OPTIONS = [10, 25, 50];

const Pagination = (props: IProps) => {
  const { onPageChange, total, perPage, currentPage } = props;

  const pageCount = Math.ceil(total / perPage);

  const onPerPageChange = (perPage: number | undefined) => {
    props.onPerPageChange(perPage ?? PER_PAGE_OPTIONS[0]);
  };

  return (
    <div className="pagination-wrapper">
      <div className="per-page-select">
        <span className="select-label">
          per page:
        </span>

        <SelectSingleInput
          itemToOption={perPage => ({
            value: perPage.toString(),
            label: perPage.toString()
          })}
          items={PER_PAGE_OPTIONS}
          name="category"
          onChange={onPerPageChange}
          selectedItem={perPage}
          placeholder="Filter by category"
        />
      </div>

      <ReactPaginate
        forcePage={currentPage}
        pageCount={pageCount}
        onPageChange={(selectedItem => onPageChange(selectedItem.selected))}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        nextLabel="Next"
        breakLabel="..."
        previousLabel="Previous"
        renderOnZeroPageCount={undefined}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        hrefAllControls
        hrefBuilder={() => '#'}
      />
    </div>
  )
};

export default Pagination;
